'use strict';

var _ = require('lodash');
var React = require('react');

var PictureChooser = require('./picturechooser');
var at = require('../../utils/environment');
var newPlayerInstance = require('../../utils/lazy-video');

var cssBackgroundUrl = _.template('url("<%= url %>")');


var Video = React.createClass({
    componentDidMount: function() {
        newPlayerInstance(this.refs.video);
    },

    _calculateDurationLabel: function(duration) {
        if (duration === null) return '';

        var SECOND = 1000;
        var MINUTE = SECOND * 60;
        var HOUR   = MINUTE * 60;

        var hr = Math.floor(duration / HOUR);
        duration = duration % HOUR;
        var min = Math.floor(duration / MINUTE);
        duration = duration % MINUTE;
        var sec = Math.floor(duration / SECOND);

        if (hr > 0)
            return this._roundsDuration(hr + (min * 0.01)) + ' hr';
        if (min > 0)
            return this._roundsDuration(min + (sec * 0.01)) + ' min';
        if (sec > 0)
            return this._roundsDuration(sec) + ' seg';

        return '';
    },

    _roundsDuration: function(value) {
        // Somamos com 0.69 para que:
        // 15:31 vire 16:00
        // 15:30 vire 15:00
        return Math.floor(value + 0.69);
    },

    render: function() {
        var duration = null;
        var trademark = null;
        var aggregated = this.props.aggregated;
        var videoInfo = this.props.content.video;
        var content = this.props.content;
        var imageUrl;
        var img = null;
        var alt = null;
        var cover = {};

        if (!videoInfo) return null;

        // picturechooser não parece um bom nome se
        // você passar um objeto content
        if (at.client) {
            imageUrl = PictureChooser.choose(this.props.content);
            if (imageUrl === null) return null;
            else {
                cover = { backgroundImage: cssBackgroundUrl({ url: imageUrl }) };
                alt = this.props.content.title;
                img = <img src={imageUrl} alt={alt} />;
            }
        }

        if (typeof(videoInfo.duration) === 'number') {
            duration = this._calculateDurationLabel(videoInfo.duration);
            trademark = (videoInfo.trademark || null);
        }

        if (!aggregated && trademark && trademark !== '')
            trademark = (
                <div>
                    <img className='feed-post-video-trademark' src={trademark} />
                    <span className='feed-post-video-gradient'></span>
                </div>
            );
        else trademark = '';

        return (
            <figure className='gui-image-full gui-video-full'
                    style={cover}
                    alt={alt}
                    title={alt}
                    ref="video"
                    data-video-id={videoInfo.id}
                    data-short-url={content.url}
                    data-link={content.url}
                    data-title={alt}>
                <span className='gradient'></span>
                <p className='feed-post-video-duration'>{duration}</p>
                {img}
                <div className='gui-icon gui-icon-play1'></div>
                {trademark}
            </figure>
        );
    }
});

module.exports = Video;
